import { observer } from 'mobx-react';

import { AppLogo } from '../../../components/SVGIcons/AppLogo/AppLogo';
import type { WizardChildProps } from '../../../components/Wizard/types';
import { useMediaQuery } from '../../../hooks/useMediaQuery';

import { ForgotPasswordSection } from './components/ForgotPasswordSection';
import classes from './DirectRegLanding.module.scss';

interface ForgotPasswordLandingProps extends WizardChildProps {
  onPasswordResetSuccess?: () => void;
}

const ForgotPasswordLanding = observer(
  ({ nextStep, prevStep, forceStep, isCurrent, onPasswordResetSuccess }: ForgotPasswordLandingProps) => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    return (
      <div className={classes.directRegLandingContainer}>
        <div className={classes.directRegLanding}>
          <div className={classes.logoSection}>
            <AppLogo
              alwaysColorful
              withText
              textClassname={classes.logoText}
              textColor="#fff"
              width={isMobile ? 58 : 82}
            />
          </div>

          <div className={classes.bannerSection}>
            <ForgotPasswordSection
              forceStep={forceStep}
              isCurrent={isCurrent}
              nextStep={nextStep}
              prevStep={prevStep}
              onPasswordResetSuccess={onPasswordResetSuccess}
            />
          </div>
        </div>
      </div>
    );
  },
);

export default ForgotPasswordLanding;
